import React, { useState } from "react";
import useFetch from "../../hooks/useFetch";
import Button from "../Button";
import BurgerIcon from "../BurgerIcon";
import "./style.scss";

function Navigation() {
  const [menu, loading] = useFetch("/menus/main-menu", []);
  const [open, setOpen] = useState(false);
  
  return (loading ? null :
    <nav className={`Navigation${open ? " Navigation--open" : ""}`}>
      <ul className="Navigation__list" onClick={e => {if (e.target.classList.contains("button")) setOpen(false)}}>
        {menu.map((item, index) => (
          index % 3 === 0 ? (
            <NavigationButton key={item.id} item={item} size="small" />
          ) : (
            <NavigationButton key={item.id} item={item} />
          )
        ))}
      </ul>
      <button className="Navigation__burger" onClick={() => setOpen(prev => !prev)}>
        <BurgerIcon />
      </button>
    </nav>
  );
}

function NavigationButton({item, size="tiny"}) {
  return (
    <li
      className={`NavListItem NavListItem--${size}`}
    >
      <Button
        to={item.url}
        color={item.color}
        size={size}
      >
        {item.title}
      </Button>
    </li>
  );
}

export default Navigation;
